import { createFileRoute, redirect } from '@tanstack/react-router'
import { TransferFormScreen } from '@/features/inventory-transfers/transfer-form-screen'
import { hasGrant } from '@/lib/me'

const text = (value: unknown) => (typeof value === 'string' && value !== '' ? value : undefined)

export const Route = createFileRoute('/_authenticated/inventory/transfers/new')({
  // Optional pre-fill, e.g. "Raise transfer" on a low-stock alert (WP02):
  // the destination warehouse and the product to send there.
  validateSearch: (
    search: Record<string, unknown>,
  ): { to?: string; product?: string; variant?: string; sku?: string } => ({
    to: text(search.to),
    product: text(search.product),
    variant: text(search.variant),
    sku: text(search.sku),
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'stock_transfer.create'))
      throw redirect({ to: '/inventory/transfers' })
  },
  component: TransferFormScreen,
})
